module.exports = __webpack_public_path__ + "img/images/new-landing/MS.png?ea7a6c32";